import { Reseller } from '../../types'

const resellers: Reseller[] = [
	{
		id: 9,
		name: 'Balloon Supplies 4 U',
		email: 'info@balloon.com',
		phone_number: '098765434567',
		address1: 'Balloon Ltd, Camrascan house',
		address2: 'Lynchwood',
		postcode: 'HB56GV',
		service_provider_id: 2
	},
	{
		id: 10,
		name: 'Birchen',
		email: 'bob@birchen.com',
		phone_number: '09876545678',
		address1: 'address1',
		address2: 'address2',
		postcode: 'TR57VG',
		service_provider_id: 2
	}
]

export default resellers
